export const CLUB_PER_PAGE = 10;
export const CENTRE_RUGBY_LAT = 48.637819; // En attente d'un module pour gérer la position
export const CENTRE_RUGBY_LONG = 2.247357; // En attente d'un module pour gérer la position
export const CLUB_FILTER_DISTANCES = [10, 20, 40, 80, 160, 500];
